// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + {"102":"xlsx","133":"pdfmake","182":"canvg"}[chunkId] + "." + {"102":"04df9e62","133":"9576d92f","182":"e726b1dd"}[chunkId] + ".chunk.js";
};